import React, { FC } from 'react';
import { WithStyle } from '../../utils';
import { NotificationProps } from './types';
import { Button } from '../button';
import { NotificationStyled } from './notification.styled';
import { Box } from '../box';
import IconCheckRound from '../icon/icons/check-round';
import IconInfoRound from '../icon/icons/info-round';

export const Notification: FC<NotificationProps> & WithStyle = props => {
  const { id, type, title, buttonTitle, onClickButton } = props;
  return (
    <NotificationStyled $type={type} {...{ id, buttonTitle }}>
      {type === 'error' ? <IconInfoRound /> : <IconCheckRound />}
      <Box $display="flex" $alignItems="center" $justifyContent="space-between">
        <span>{title}</span>
        {buttonTitle && <Button onClick={onClickButton}>{buttonTitle}</Button>}
      </Box>
    </NotificationStyled>
  );
};

Notification.displayName = 'Notification';
Notification.Style = NotificationStyled;
